﻿export function setupCommenting() {
    const commentingBox = `commentingBox${$('[data-main-content]').data('main-content')}`;
    window.commentBox = function () {
        if (window.isViewportGreaterThanOrEqualTo('lg')) {
            $('.comment-box .panel-collapse.collapse').removeClass();
        } else  {
            const commentingClass = $(`#${commentingBox}`).attr("class");
            if (commentingClass == '') {
                $(`#${commentingBox}`).addClass('panel-collapse collapse');
            } else if (commentingClass == 'collapse in') {
                $(`#${commentingBox}`).removeClass().addClass('panel-collapse collapse');
            }

        }
    }

    window.commentBoxDesktop = function () {
        if (window.isViewportGreaterThanOrEqualTo('lg')) {
            const commentingClass = $(`#${commentingBox}`).attr("class");
            if (commentingClass == '') {
                $(`#${commentingBox}`).removeClass().addClass('collapse in');
            } else if (commentingClass == 'collapse in') {
                $(`#${commentingBox}`).removeClass().addClass('collapse');
            } else if (commentingClass == 'collapse') {
                $(`#${commentingBox}`).removeClass().addClass('collapse in');
            }
        }
    }

    window.commentBox();
    $(window).resize(function () {
        window.commentBox();
    });
    $(document).on("click", ".comment-box .panel-heading a", window.commentBoxDesktop);
}